// Program Status's API returns a flat list with a dot-joined ancestor `path` (e.g. "1.2.16")
// instead of a nested `subRows` tree like the other reports — react-table's useExpanded needs
// `subRows` to know a row can expand, so this builds that tree client-side.
export function buildProgramTree(rows) {
  const byId = new Map();
  rows.forEach((row) => {
    byId.set(row.id, { ...row, subRows: [] });
  });

  const roots = [];
  rows.forEach((row) => {
    const node = byId.get(row.id);
    const segments = String(row.path).split(".");
    const parentId = segments.length > 1 ? Number(segments[segments.length - 2]) : null;
    const parent = parentId !== null ? byId.get(parentId) : null;

    if (parent) {
      parent.subRows.push(node);
    } else {
      roots.push(node);
    }
  });

  return roots;
}
